import { WidgetConfig } from '@wix/da-gruser-shared/pkg/types/widget';
import defaultRemoveConfirmation from '@wix/da-shared-react/pkg/widgets/defaultRemoveConfirmation';
import WatchedDeviantsBox from './WatchedDeviantsBox';
import WatchedDeviantsConfigPopoverLazy from './WatchedDeviantsConfigPopover/WatchedDeviantsConfigPopoverLazy';

export const getWatchersWidgetConfig = ({ t, dispatch }): WidgetConfig => ({
  viewComponent: WatchedDeviantsBox,
  configPopoverComponent: WatchedDeviantsConfigPopoverLazy,
  confirmRemove: () => defaultRemoveConfirmation({ t, dispatch }),
  widgetCard: {
    minuatureImageSrc:
      'https://st.deviantart.net/eclipse/widgets/miniatures/2022/il8-12-watchers.svg',
    title: 'widgets.watchers.addButtonHeader',
    description: 'widgets.watchers.description',
  },
});

export const getWatchingWidgetConfig = ({ t, dispatch }): WidgetConfig => ({
  viewComponent: WatchedDeviantsBox,
  configPopoverComponent: WatchedDeviantsConfigPopoverLazy,
  confirmRemove: () => defaultRemoveConfirmation({ t, dispatch }),
  widgetCard: {
    minuatureImageSrc:
      'https://st.deviantart.net/eclipse/widgets/miniatures/2022/il8-13-watching.svg',
    title: 'widgets.watching.addButtonHeader',
    description: 'widgets.watching.description',
  },
});
